<template>
  <div class="gnosis-status-check">
    <div class="heading-5 font-weight-medium">Connect Gnosis Safe</div>
    <div class="mt-8">
      <div class="d-flex align-center">
        <div class="p-14-r gray--text">01</div>
        <div class="h1-26-m ml-5">KYC Required</div>
        <div :class="['p-14-r text-uppercase ml-8 px-3 rounded-5', status]">
          {{ statusMap[status] }}
        </div>
      </div>
      <p class="p-14-r darkgray--text mt-3">
        An email with a list of mandatory documents and information
        <span v-if="status === 'new'">will be</span>
        <span v-else>has been</span>
        sent to your registered email address. Please submit all KYC
        documentation by replying to the email. You will receive an update on
        the review within 48 hours.
      </p>
    </div>
    <div class="mt-8">
      <div class="d-flex align-center">
        <div class="p-14-r gray--text">02</div>
        <div class="h1-26-m ml-5">Create / Connect Gnosis Safe</div>
      </div>
      <p class="p-14-r darkgray--text mt-3">
        Once your Gnosis KYC application has been approved, connect your
        existing Gnosis Safe Multisig or create a new one.
      </p>
    </div>
    <div class="mt-5">
      <div class="d-flex justify-end align-center mt-5" v-if="status === 'new'">
        <div class="p-16-m gray--text clickable" @click="cancel">Cancel</div>
        <c-btn @click="sendRequest" class="ml-5" :loading="sendingRequest"
          >Continue</c-btn
        >
      </div>
      <div class="d-flex justify-end align-center" v-else>
        <v-tooltip top color="dark" :disabled="!unableToConnectTextExplain">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <c-btn
                is-secondary
                :disabled="!!unableToConnectTextExplain"
                @click="connect"
              >
                Connect Safe
              </c-btn>
            </span>
          </template>
          <span>{{ unableToConnectTextExplain }}</span>
        </v-tooltip>
        <v-tooltip top color="dark" :disabled="!unableToConnectTextExplain">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <c-btn
                class="ml-3"
                :disabled="!!unableToConnectTextExplain"
                @click="create"
              >
                Create Safe
              </c-btn>
            </span>
          </template>
          <span>{{ unableToConnectTextExplain }}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const STATUS_MAP = {
  new: "NEW APPLICATION",
  pending_submission: "PENDING SUBMISSION",
  pending_review: "PENDING REVIEW",
  approved: "APPROVED",
};
export default {
  computed: {
    ...mapGetters({
      walletList: "userWallets/walletList",
      userInfo: "userInfo/basicInfo",
    }),
    status() {
      return this.userInfo.verificationStatus;
    },
    statusMap() {
      return STATUS_MAP;
    },
    unableToConnectTextExplain() {
      if (this.walletList.result.find(w => w.type === "gnosis")) {
        return "You can only create/connect one Gnosis Safe.";
      }
      if (this.status !== "approved") {
        return "Your Gnosis KYC application has not been approved.";
      }
      return false;
    },
  },
  data: () => ({
    sendingRequest: false,
  }),
  methods: {
    cancel() {
      this.$store.dispatch("closeAuthModal");
    },
    async sendRequest() {
      if (this.sendingRequest) return;
      this.sendingRequest = true;
      await this.$store.dispatch("userInfo/sendKycRequest");
      this.sendingRequest = false;
    },
    connect() {
      this.$emit("setStep", "2.2");
    },
    create() {
      this.$emit("setStep", "2.1");
    },
  },
};
</script>

<style lang="scss" scoped>
.gnosis-status-check {
  .new {
    color: var(--orange);
    background: rgba(246, 96, 51, 0.1);
  }
  .pending_submission,
  .pending_review {
    color: var(--orange);
    background: rgba(255, 207, 38, 0.1);
  }
  .approved {
    color: var(--green);
    background: rgba(74, 216, 152, 0.1);
  }
}
</style>
